import { FC } from 'react';
import { css } from '@emotion/react';
import { spacing, colors } from '../../../styles';
import { ToolRendererProps } from './types';

export const CollectionsRenderer: FC<ToolRendererProps> = ({ output, isLoading }) => {
  if (isLoading) {
    return (
      <div
        css={css`
          font-size: 14px;
          color: ${colors.silver};
        `}
      >
        Finding collections...
      </div>
    );
  }

  // Check if we only have a message (no cards/collections data) - this happens when cards are sent separately
  const cards = output.cards || output.collections || [];
  if (output.message && (!Array.isArray(cards) || cards.length === 0)) {
    return (
      <div
        css={css`
          font-size: 14px;
          color: ${colors.silver};
        `}
      >
        {output.message}
      </div>
    );
  }
  if (!Array.isArray(cards) || cards.length === 0) {
    return (
      <div
        css={css`
          font-size: 14px;
          color: ${colors.silver};
        `}
      >
        No collections found
      </div>
    );
  }

  return (
    <div
      css={css`
        margin: ${spacing.centi} 0 0 0;
      `}
    >
      <div
        css={css`
          font-size: 12px;
          color: ${colors.silver};
          margin-bottom: ${spacing.centi};
        `}
      >
        Found {cards.length} collections
      </div>
      {cards.map((collection: any, index: number) => (
        <div
          key={index}
          css={css`
            margin-bottom: ${spacing.centi};
            line-height: 1.4;
          `}
        >
          <div
            css={css`
              font-size: 14px;
              color: ${colors.liquorice};
              margin-bottom: ${spacing.micro};

              html[data-theme='dark'] & {
                color: ${colors.sugar};
              }
            `}
          >
            {collection.name}
          </div>
          <div
            css={css`
              font-size: 12px;
              color: ${colors.silver};
            `}
          >
            {collection.description || `${collection.symbol_count || 0} stocks`}
          </div>
        </div>
      ))}
    </div>
  );
};
